// Bon d'intervention sans réseau (31/10/2026) : règles d'affichage pures (testées sans navigateur, tests/unit/bons-hors-ligne-conservation.test.ts).

/**
 * Pourquoi « Faire signer » est désactivé, ou null s'il ne l'est pas. La signature exige le réseau (heure du serveur, PDF, empreinte,
 * verrou du bon) : jamais de signature différée ; et rien ne se signe tant qu'un enregistrement du bon est encore sur le téléphone
 * (le bon signé ne serait pas celui que le technicien a rempli) ou a été refusé. `court` : sous la barre d'action (téléphone) ;
 * `long` : bulle et description lue par les lecteurs d'écran.
 */
export function raisonSignatureBloquee(o: { enLigne: boolean; enAttente: number; refusees: number }): { court: string; long: string } | null {
  if (!o.enLigne) return { court: 'Signature : au retour du réseau.', long: 'Hors connexion : la signature demande le réseau (heure du serveur, PDF, empreinte, verrou du bon).' };
  if (o.enAttente > 0) {
    return { court: 'Signature : après l’envoi des modifications.',
      long: 'Des modifications de ce bon sont encore sur ce téléphone : elles doivent arriver sur le serveur avant la signature.' };
  }
  if (o.refusees > 0) {
    return { court: 'Signature : après reprise ou abandon des modifications.',
      long: 'Un enregistrement de ce bon a été refusé : reprenez ou abandonnez vos modifications avant de faire signer.' };
  }
  return null;
}

/** Pourquoi « Ajouter la note » est désactivé, ou null : une note demande le réseau (heure du serveur ; pas de file hors connexion). */
export function raisonNoteBloquee(o: { enLigne: boolean }): string | null {
  return o.enLigne ? null : 'Hors connexion : une note s’ajoute avec le réseau (date et heure du serveur). Elle n’est pas gardée sur ce téléphone.';
}
